import React from "react";

export default function CreateSchemaTableHooks() {
  const parseCreateTable = (sqlString) => {
    const createTableRegex =
      /CREATE TABLE\s+(\w+)\s*\(([\s\S]+?)\)\s*(ENGINE|;)/gi;

    let match;
    let tables = [];

    while ((match = createTableRegex.exec(sqlString)) !== null) {
      const tableName = match[1];

      let buffer = "";
      let columnLines = [];
      let insideParentheses = false;
      let columnsDefinition = match[2];

      for (let char of columnsDefinition) {
        if (char === "(") insideParentheses = true;
        if (char === ")") insideParentheses = false;

        if (char === "," && !insideParentheses) {
          columnLines.push(buffer.trim());
          buffer = "";
        } else {
          buffer += char;
        }
      }

      if (buffer.trim()) columnLines.push(buffer.trim());

      const columns = columnLines
        .filter(
          (line) =>
            !line.toLowerCase().startsWith("constraint") &&
            !line.toLowerCase().startsWith("primary key") &&
            !line.toLowerCase().startsWith("foreign key") &&
            line.length > 0
        )
        .map((col) => {
          const parts = col.split(/\s+/);
          const column_name = parts[0];
          const type = parts.slice(1).join(" ");

          return { column_name, type };
        });

      tables.push({ tableName, columns });
    }

    return tables;
  };

  return { parseCreateTable };
}
